import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";
import { withToastManager } from "react-toast-notifications";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import Loader from "../../Components/Loader/DotLoader";

import AllRequests from "./AllRequests";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

interface IProps {
  toastManager: any;
}

class Requests extends React.Component<IProps> {
  state = {
    modal: false
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (): void => {
    this.setState({
      modal: true
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the data</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <br />
              <br />
              <AllRequests
                companyId={companyId}
                toastManager={this.props.toastManager}
              />
              <Helmet title="Requests" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}

export default withToastManager(Requests);



// WEBPACK FOOTER //
// ./src/Containers/Requests/index.tsx